import { render } from "./BaseQrCode.vue?vue&type=template&id=c8c3e9d0"
import script from "./BaseQrCode.vue?vue&type=script&lang=js"
export * from "./BaseQrCode.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__